<template>
	<div id='top'>
		<el-row>
			<el-col :span="4">&nbsp;</el-col>
			<el-col :span="16">
				 {{getErrorText}} 
			</el-col>
			<el-col :span="4">&nbsp;</el-col>
		</el-row>
		<el-row>
			<el-col :span="4">&nbsp;</el-col>
			<el-col :span="16" class="video">
        <iframe width="100%" height="100%" src="http://www.youtube.com/embed/SkgTxQm9DWM?autoplay=1&cc_load_policy=1" frameborder="0" allowfullscreen></iframe>
			</el-col>
			<el-col :span="4">&nbsp;</el-col>
		</el-row>

	</div>
</template>

<script>
	export default {
		name: 'project-error',
		computed: {
			getErrorText: function() {
				switch (this.$store.state.plc_state.error) {
					case 1:
						return 'Too many retries'
					case 2:
						return 'Robot doesn\'t know what to do'
					case 3:
						return 'Abort requested by robobrain'
					case 4:
						return 'Something is out of range'
					case 5:
						return 'There are no reject positions left'
				}
				return 'Unknown error'
			}
		}
	}
</script>

<style scoped>
	.el-col {
		color: #FF2222;
    font-size: 200%;
    text-align: center;
	}
  .video {
    height: 600px;
  }
</style>



// WEBPACK FOOTER //
// project-error.vue?34b11a84